import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextLarge, HeadlineTextLarge, TitleTextLarge } from 'Packages/FacetDesign/Components';
import { withValueArray } from 'Helpers/MetaOverride';
import { FDStat } from '@facet-wealth/design';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
    _customProps: {
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly, { ordinal: 200 })
  .nameOverride('subtitle', {
    _component: () => withValueArray(BodyTextLarge),
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('contributionsType', {
    _component: () => FDStat,
  }, overrideReadOnly)
  .nameOverride('destinationAccountName', {
    _component: () => TitleTextLarge,
  }, overrideReadOnly);
